import React from 'react'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LaunchIcon from '@material-ui/icons/Launch'

import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import Link from '@material-ui/core/Link'

/*
    Implements a dropdown using Material UI
    mostly lifted from: 
    https://material-ui.com/components/button-group/
    (they call it a "Split button")

*/
export const DropdownButton = ({
  text,
  items,
  order,
  onClick,
  color = '#000',
  onDropdownOpen,
  menuID = 'null',
}) => {
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)
  const calculateDropdownAlignment = function () {
    if (anchorRef.current) {
      let dropdownList = anchorRef.current.children[2]

      let dropdownHeight = dropdownList.clientHeight
      let viewportOffset = dropdownList.getBoundingClientRect()
      let dropdownOrientation = 'bottom'
      let maxDropdownHeight = viewportOffset.bottom
      if (viewportOffset.top > viewportOffset.bottom) {
        dropdownOrientation = 'top'
        maxDropdownHeight = viewportOffset.top
      }
      dropdownList.style.maxHeight = maxDropdownHeight + 'px'
      dropdownList.classList.remove('orientation-top')
      dropdownList.classList.remove('orientation-bottom')
      dropdownList.classList.add(`orientation-${dropdownOrientation}`)
    }
  }
  const handleClick = (id, text, url) => {
    setOpen(false)

    onClick && onClick(id, text, url)
  }

  const handleToggle = (menuID, text) => {
    onDropdownOpen && onDropdownOpen(menuID, text)
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    setOpen(false)
  }
  const buttonStyle = {
    backgroundColor: color,
    border: 'none',
  }
  // const parentStep =  anchorRef.current.
  // console.log(anchorRef.current)

  //If dropdown is mounted and in a step, make sure the step doesn't "clip" the dropdown.
  const overflowDetails = () => {
    if (
      anchorRef.current &&
      anchorRef.current.closest('.sponsored-flow-panel')
    ) {
      return {
        enabled: true,
        boundary: anchorRef.current.closest('.sponsored-flow-panel'),
      }
    } else {
      return {
        enabled: false,
      }
    }
  }
  const thisDropdownOverflow = overflowDetails()
  return (
    <>
      <div className="content-item dropdown-button" style={{ order: order }}>
        <ButtonGroup
          variant="contained"
          color="primary"
          ref={anchorRef}
          aria-label="split button"
          className={`themed-button-group`}
        >
          <Button
            onClick={event => {
              handleToggle(menuID, text)
            }}
            style={buttonStyle}
            className={`themed-button`}
          >
            {text}
          </Button>
          <Button
            color="primary"
            size="small"
            className={`themed-button`}
            style={buttonStyle}
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={event => {
              handleToggle(menuID, text)
            }}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={'list'}
          transition
          className="dropdown-popper"
          disablePortal
          modifiers={{
            flip: {
              enabled: true,
              allowedAutoPlacements: ['top', 'bottom'],
            },
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" className={`themed-menu`}>
                    {items.map((item, index) => (
                      <MenuItem
                        key={index}
                        tabIndex={0}
                        // onClick={(event) => handleClick }
                        onClick={event => {
                          // need to use this syntax to hoist up handleClick()
                          handleClick(item.id, item.label, item.link)
                        }}
                        component={Link}
                        href={item.link}
                        rel="noopener noreferrer"
                        target="_blank"
                        className={`themed-menu-link`}
                      >
                        {item.label}
                        <LaunchIcon />
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </>
  )
}
